import { createFileRoute } from '@tanstack/react-router';

import { ClubTermsPage } from '@/pages/club/profile/terms/ClubTermsPage';

export const Route = createFileRoute('/clubOwner/$id/profile_/_profile/terms')({
  component: ClubTermsPage
});
